/*********************** Custom JS for Boost AI Search & Discovery  ************************/

window.__BoostCustomization__  = (window.__BoostCustomization__ ?? []).concat([
 (componentRegistry) => {
  componentRegistry.useComponentPlugin('ProductItem', {
   name: 'Modify Product Item',
   enabled: true,
   apply: () => ({
    beforeRender(element) {
      try {
        const item = element.getRootElm();
        if (!item){
          return;
        }
        if (!item.querySelector(".boost-sd__product-link") || !item.querySelector(".boost-sd__product-link").href) return;
        const collectionHandle = document.querySelector("body").dataset.collectionHandle;
        let url = item.querySelector(".boost-sd__product-link").href + "?view=boost-item";
        if (collectionHandle) {
          url = url.replace("/products", "/collections/" + collectionHandle + "/products")
        }
        fetch(url)
          .then(res => {
            if (res.status != 404) {
              return res.text()
            }
            return null;
          })
          .then(res => {
            if (res) {
              item.innerHTML = res
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    afterRender(element) {
      
    }, 
   }),
  });
 }
]);

window.__BoostCustomization__  = (window.__BoostCustomization__ ?? []).concat([
 (componentRegistry) => {
  componentRegistry.useComponentPlugin('PaginationButton', {
   name: 'Modify Pagination',
   enabled: true,
   apply: () => ({
    beforeRender(element) {
      try {
        if (element.getRootElm()) {
          element.getRootElm().innerHTML = "<img src='https://cdn.shopify.com/s/files/1/0555/2046/0977/files/Arrow.png?v=1706718082' width=12 height=auto alt='Arrow Icon'>"
        }
      } catch (error) {
        console.log(error);
      }
    },
    afterRender(element) {}, 
   }),
  });
 }
]);

let genderCategoryAdded = false;
window.__BoostCustomization__  = (window.__BoostCustomization__ ?? []).concat([
 (componentRegistry) => {
  componentRegistry.useComponentPlugin('FilterTreeVertical', {
   name: 'Add Subcategory',
   enabled: true,
   apply: () => ({
    beforeRender(element) {
    },
    afterRender(element) {
      try {
        const filterTreeOptions = element.getRootElm().querySelector(".boost-sd__filter-tree-vertical-option-list");
        const alreadyExists = element.getRootElm().querySelector("[data-filter-subcategory]");
        if (!filterTreeOptions || alreadyExists || genderCategoryAdded) return;
        genderCategoryAdded = true;
        fetch(window.Shopify.routes.root + "?sections=boost-men-women-filter")
          .then(res => res.json())
          .then(res => {
            const subcategoryFilter = res["boost-men-women-filter"]
            let newDiv = document.createElement("div");
            newDiv.innerHTML = subcategoryFilter;
            if(subcategoryFilter) {
              filterTreeOptions.prepend(newDiv)
            }
          })
      } catch (error) {
        console.log(error);
      }
    }, 
   }),
  });
 }
]);

window.__BoostCustomization__  = (window.__BoostCustomization__ ?? []).concat([
 (componentRegistry) => {
  componentRegistry.useComponentPlugin('ProductCount', {
   name: 'Add comma to total',
   enabled: true,
   apply: () => ({
    beforeRender(element) {
    },
    afterRender(element) {
      try {
        const numberElement = element.getRootElm();
        var text = numberElement.innerText;
        var number = text.split(' ')[0];
        if (number.includes(","))return;
        var formattedNumber = parseInt(number).toLocaleString();
        numberElement.innerText = formattedNumber + ' products';
      }
      catch(err){
        console.log(err);
      }
    }, 
   }),
  });
 }
]);